import moment from "moment";
import LostDeal from "../../../../mainDeals/deals/deal/lost-deal/lost-form-deal";
import DealQuickView from "../../../../mainDeals/deals/deal/popup";
import WonDeal from "../../../../mainDeals/deals/deal/won-deal/won-form-deal";
import EmployeeDirectoryAddUpdate from "../../../../organization/emplyee-directory/add-update";
import {
  Calendar,
  Check,
  Clock,
  Copy,
  CopyCheck,
  Pencil,
  Settings2,
  ThumbsDown,
  ThumbsUp,
  Trophy,
  User,
  XCircle,
} from "lucide-react";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import Swal from "sweetalert2";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import { Suspense, useEffect, useState } from "react";
import Style from "../style.module.css";
import CustomizeTabsOverviewPopup from "./customize-tabs-popup";
import { useMemo } from "react";
// import FilesTab from "../../../../../component/files";
import CommentsSection from "../../../../../component/comment";
import DOMPurify from "dompurify";
import Icon from "../../../../../component/icons/inner-pages-icons";
// import CommentsSection from "./comments";
import FilesTab from "./files";
import FollowUpPopup from "../../follow-ups";
import {
  FollowUpsTab,
  TimelineTab,
} from "../../../../../component/ui/timeline";

const CopyIcon = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <div
        className="ms-2 hover:opacity-50 cursor-pointer transition-all"
        onClick={() => {
          copyToClipboard(text);
        }}
      >
        {isCopied ? (
          <CopyCheck size={15} color="#333" />
        ) : (
          <Copy size={15} color="#333" />
        )}
      </div>
    </>
  );
};

function NewField({ label, value, icon: Icon }) {
  const isUrl =
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"));

  const hasHtml = typeof value === "string" && /<\/?[a-z][\s\S]*>/i.test(value);

  const cleanHtml = hasHtml ? DOMPurify.sanitize(value) : value;
  const [showAll, setShowAll] = useState(false);

  const limit = 70;
  const isLongText = value?.length > limit;

  const displayText =
    !isLongText || showAll ? value : value.slice(0, limit) + "...";

  return (
    <div className="flex flex-col gap-y-[10px]">
      <div className="flex gap-[10px] items-center">
        {Icon && <Icon size={16} />}
        <p className="text-xs font-medium">{label}</p>
      </div>

      {isUrl ? (
        <div className="flex justify-between text-[14px] w-full font-normal text-[#999]">
          <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:underline"
          >
            {value?.length > 100 ? `${value.slice(0, 50)}...` : value}
          </a>
          <CopyIcon text={value} />
        </div>
      ) : hasHtml ? (
        <div
          className="text-sm text-[rgba(14,18,27,0.40)] prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: cleanHtml }}
        />
      ) : (
        <>
          {/* // <div className="text-sm font-medium text-[rgba(14,18,27,0.40)]">
        //   {value || "-"}
        // </div> */}
          {/* Value */}
          <div className="text-sm font-medium text-[rgba(14,18,27,0.40)]">
            {displayText}

            {isLongText && (
              <button
                onClick={() => setShowAll(!showAll)}
                className="ml-1 text-[#0057FB] text-xs font-medium hover:underline"
              >
                {showAll ? "Show less" : "Show more"}
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}

const T = {
  bg: "#EDE8E1",
  sidebar: "#1a1730",
  sidebarHover: "#252240",
  sidebarActive: "#302d4a",
  card: "#FFFFFF",
  cardBorder: "rgba(0,0,0,0.08)",
  text: "#1a1520",
  textSecondary: "#5c5466",
  textMuted: "#908892",
  accent: "#6366f1",
  accentLight: "rgba(99,102,241,0.08)",
  accentText: "#5457e5",
  shadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
  shadowMd: "0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
  shadowLg: "0 8px 30px rgba(0,0,0,0.08)",
  inputBg: "#F3EFE9",
  inputBorder: "rgba(0,0,0,0.1)",
};

// const STATUS_COLORS = {
//   "Need Analysis": "#f59e0b",
//   "Value Proposition": "#3b82f6",
//   "Identify Decision": "#8b5cf6",
//   Proposal: "#06b6d4",
//   Review: "#10b981",
//   "Closed Won": "#22c55e",
//   Won: "#22c55e",
//   "Closed Lost": "#ef4444",
//   Lost: "#ef4444",
// };

const STATUS_COLORS = {
  "Need Analysis": "#1A73E8",
  "Value Proposition": "#00838F",
  "Identify Decision": "#9333EA",
  Proposal: "#e65100",
  Review: "#6D4C41",
  "Closed Won": "#388e3c",
  Won: "#388e3c",
  "Closed Lost": "#b91c1c",
  Lost: "#b91c1c",
};

const STAGES = [
  "Need Analysis",
  "Value Proposition",
  "Identify Decision",
  "Proposal",
  "Review",
  "Won",
  "Lost",
];

function NewMetaField({ label, value }) {
  const isUrl =
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"));
  const [showAll, setShowAll] = useState(false);

  const limit = 60;
  const isLongText = value?.length > limit;

  const displayText =
    !isLongText || showAll ? value : value.slice(0, limit) + "...";
  return isUrl ? (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 0",
          borderBottom:
            // i < 6 ? `1px solid ${T.cardBorder}` : "none",
            `1px solid ${T.cardBorder}`,
        }}
      >
        <div style={{ fontSize: 12, color: T.textMuted }}>{label}</div>

        <div className="flex justify-between font-mono text-[13px]  font-medium text-[#1a1520] min-w-0">
          <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:underline break-all whitespace-normal min-w-0"
          >
            {value?.length > 50 ? `${value?.slice(0, 30)}...` : value}
          </a>

          <CopyIcon text={value} />
        </div>
      </div>
    </>
  ) : (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 0",
        borderBottom:
          // i < 6 ? `1px solid ${T.cardBorder}` : "none",
          `1px solid ${T.cardBorder}`,
      }}
    >
      <div style={{ fontSize: 12, color: T.textMuted }}>{label}</div>

      {/* Value */}
      <div className="text-[13px]  font-medium text-[#1a1520] break-words whitespace-normal max-w-[80%]">
        {displayText || "-"}

        {isLongText && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="ml-1 text-[#0057FB] text-xs font-medium hover:underline"
          >
            {showAll ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    </div>
  );
}

// ─── HELPERS ───
const activityIcons = {
  call: "phone",
  phone: "phone",
  email: "mail",
  sms: "sms",
  consultation: "consultation",
  default: "default",

  note: "note",
  meeting: "calendar",
  "follow-up": "calendar",
  followup: "calendar",
  stage: "arrowRight",
  voicemail: "mic",
  chat: "sms",
  comment: "sms",
  demo: "demo",
  messasge: "sms",
  presentation: "presentation",
  assign: "assign",
  unassign: "unassign",
  file: "file",
  brief: "brief",
};

const activityColors = {
  call: "#3b82f6", // blue
  email: "#8b5cf6", // violet
  sms: "#06b6d4", // cyan
  consultation: "#f59e0b", // amber
  note: "#f59e0b", // amber
  meeting: "#10b981", // emerald
  stage: "#6366f1", // indigo
  // "follow-up": "#6366f1", // indigo
  "follow-up": "#06b6d4", // indigo
  voicemail: "#ef4444", // red

  chat: "#0ea5e9", // sky blue
  presentation: "#14b8a6", // teal
  demo: "#a855f7", // purple
  default: "#a855f7", // purple
  messasge: "#f43f5e", // rose

  // remaining icons (added)
  phone: "#3b82f6", // blue
  comment: "#0ea5e9", // sky
  followup: "#06b6d4", // indigo
  assign: "#22c55e", // green
  unassign: "#ef4444", // red
  file: "#eab308", // slate
  brief: "#eab308", // yellow
};
const priorityColors = { high: "#ef4444", medium: "#f59e0b", low: "#10b981" };

// ─── COMPONENTS ───

const Badge = ({ color, children, style = {} }) => (
  <span
    style={{
      display: "inline-flex",
      flexShrink: 0,
      alignItems: "center",
      gap: 4,
      padding: "3px 10px",
      borderRadius: 6,
      fontSize: 11,
      fontWeight: 600,
      background: color + "14",
      color,
      letterSpacing: "0.3px",
      ...style,
    }}
  >
    {children}
  </span>
);

const Card = ({ children, style = {}, hover = false, onClick }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => hover && setHovered(true)}
      onMouseLeave={() => hover && setHovered(false)}
      style={{
        background: T.card,
        border: `1px solid ${T.cardBorder}`,
        borderRadius: 12,
        boxShadow: hovered ? T.shadowMd : T.shadow,
        transform: hovered ? "translateY(-1px)" : "none",
        transition: "all 0.15s ease",
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const ActionButton = ({
  icon,
  label,
  color = T.accent,
  variant = "outline",
  onClick,
  style = {},
}) => {
  const [hovered, setHovered] = useState(false);
  const filled = variant === "filled";
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "10px 16px",
        borderRadius: 10,
        border: filled ? "none" : `1px solid ${color}30`,
        background: filled
          ? hovered
            ? color
            : color + "ee"
          : hovered
            ? color + "10"
            : color + "06",
        color: filled ? "#fff" : color,
        cursor: "pointer",
        fontSize: 13,
        fontWeight: 600,
        fontFamily: "inherit",
        transition: "all 0.15s",
        width: "100%",
        boxShadow: filled ? `0 2px 8px ${color}35` : "none",
        ...style,
      }}
    >
      <Icon name={icon} size={15} color={filled ? "#fff" : color} /> {label}
    </button>
  );
};

const Details = ({
  leadDetail,
  DealStages = [],
  onSuccess = () => {},
  onError = () => {},
  activeDealData = {},
  updateData = () => {},
  clientDeals = [],
}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showWonModal, setShowWonModal] = useState(false);
  const [wonFormDeal, setWonFormDeal] = useState(null);
  const [showLostModal, setShowLostModal] = useState(false);
  const [lostFormDeal, setLostFormDeal] = useState(null);

  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});

  const [localStage, setLocalStage] = useState(
    activeDealData?.current_stage?.dealstatus ?? "-",
  );

  const apiCall = useApiCall();

  const handleSuccess = (message) => {
    if (onSuccess) onSuccess(message); // ✅ call parent prop
    setEmpPopup(false);
    setEmpData({});
  };

  const handleError = (message) => {
    if (onError) onError(message); // ✅ call parent prop
  };

  const metas = Object.fromEntries(
    activeDealData?.metas?.map((m) => [m?.meta_key, m?.meta_value]) ?? [],
  );

  const isWon = activeDealData?.current_stage?.dealstatus === "Won";
  const isLost = activeDealData?.current_stage?.dealstatus === "Lost";
  const currentStageIndex = DealStages.findIndex(
    (s) => s.name === activeDealData?.current_stage?.dealstatus,
  );
  const activeColor = isWon ? "#22c55e" : isLost ? "#ef4444" : "#2563eb";
  const isWonOrLost = isWon || isLost;

  const formatStageKey = (stage) => {
    return stage.toLowerCase().replace(/\s+/g, "_"); // "In Progress" -> "in_progress"
  };

  // --- HANDLE STAGE CHANGE ---
  const handleStageChange = async (newStage) => {
    const lowerStage = formatStageKey(newStage); // lowercase + underscores
    const currentStage = activeDealData?.current_stage?.dealstatus ?? "-"; // ✅ added

    if (lowerStage === "won") {
      setWonFormDeal(activeDealData);
      setShowWonModal(true);
      return;
    }

    if (lowerStage === "lost") {
      setLostFormDeal({
        dealkey: activeDealData.dealkey,
        name: activeDealData.name,
      });
      setShowLostModal(true);
      return;
    }

    const resultSwal = await Swal.fire({
      title: `Move deal "${activeDealData.name}"?`,
      text: `Move from "${currentStage}" to "${newStage}"?`, // ✅ fixed reference
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    });

    if (resultSwal.isConfirmed) {
      try {
        await apiCall({
          method: "post",
          url: "deals/update-deal-status",
          data: { dealkey: activeDealData.dealkey, dealstatus: lowerStage },
        });

        // **Update card immediately without reload**
        // onStatusChange(activeDealData.dealid, newStage); // ✅ keep `newStage` or `lowerStage` depending on your display logic

        const NewClientDeals = clientDeals?.map((d) =>
          d.dealid === activeDealData.dealid
            ? {
                ...d,
                current_stage: {
                  ...d.current_stage,
                  dealstatus: newStage,
                },
              } // new object
            : d,
        );

        updateData(
          {
            ...activeDealData,
            current_stage: {
              ...activeDealData.current_stage,
              dealstatus: newStage,
            },
          },
          NewClientDeals,
        );

        Swal.fire("Success!", `Deal moved to "${newStage}"`, "success");
      } catch (err) {
        Swal.fire(
          "Error",
          err?.response?.data?.message || "Something went wrong",
          "error",
        );
      }
    }
  };

  const campaignKeys = [
    "parent_url",
    "user_agent",
    "campaigned",
    "is_dropoff",
    "adgroupid",
    "keyword",
    "device",
    "matchtype",
    "msclkid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
  ];

  const excludeKeys = [
    "name",
    "email",
    "phone",
    "lead_source",
    "leadstatus",
    "leadtime",
    "country",
    "date",
  ];

  const campaignMeta = activeDealData?.metas?.filter((m) =>
    campaignKeys.includes(m.meta_key),
  );

  const otherMeta = activeDealData?.metas?.filter(
    (m) =>
      !campaignKeys.includes(m.meta_key) && !excludeKeys.includes(m.meta_key),
  );
  return (
    <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto relative">
      {/* PROGRESS / STAGES */}
      {/* <div className="flex w-full overflow-hidden pl-[3%] sticky top-0 bg-white z-10 pb-2 flex-shrink-0 pt-2 rounded-[10px] ">
        {DealStages?.map((stage, index) => (
          <div
            key={index}
            onClick={() => !isWonOrLost && handleStageChange(stage.name)} // s.name will automatically go lowercase in handleStageChange
            className={`
        relative px-10 py-4 text-sm font-medium flex-1 
        flex items-center justify-center -mx-[2%]
        ${
          index <= currentStageIndex && !isWonOrLost
            ? "bg-[#0057FB] text-white"
            : "bg-[#E5ECF2] text-[#666]"
        }
        `}
            style={{
              clipPath:
                index === 0
                  ? "polygon(80% 0px, 90% 50%, 80% 100%, 0% 100%, 10% 50%, 0% 0%)"
                  : "polygon(80% 0px, 90% 50%, 80% 100%, 0% 100%, 10% 50%, 0% 0%)",
              cursor: isWonOrLost ? "not-allowed" : "pointer",
            }}
          >
            {stage.name}
          </div>
        ))}
      </div> */}

      {/* DETAILS */}
      {/* <div className="bg-white rounded-[10px] border border-[#e1e4ea] p-5 flex flex-col gap-[10px]">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-medium leading-normal">Details</h2>

          {!isWonOrLost ? (
            <button
              onClick={() => !isWonOrLost && setShowEditModal(true)}
              className={`flex items-center gap-[10px] px-[9px] py-[5px]  transition duration-200 hover:scale-90 ${
                isWonOrLost ? "opacity-40 cursor-not-allowed" : ""
              }`}
              title="Edit Deal"
              disabled={isWonOrLost}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M11 4.00023H6.8C5.11984 4.00023 4.27976 4.00023 3.63803 4.32721C3.07354 4.61483 2.6146 5.07378 2.32698 5.63826C2 6.28 2 7.12008 2 8.80023V17.2002C2 18.8803 2 19.7204 2.32698 20.3622C2.6146 20.9266 3.07354 21.3856 3.63803 21.6732C4.27976 22.0002 5.11984 22.0002 6.8 22.0002H15.2C16.8802 22.0002 17.7202 22.0002 18.362 21.6732C18.9265 21.3856 19.3854 20.9266 19.673 20.3622C20 19.7204 20 18.8803 20 17.2002V13.0002M7.99997 16.0002H9.67452C10.1637 16.0002 10.4083 16.0002 10.6385 15.9449C10.8425 15.8959 11.0376 15.8151 11.2166 15.7055C11.4184 15.5818 11.5914 15.4088 11.9373 15.0629L21.5 5.50023C22.3284 4.67181 22.3284 3.32866 21.5 2.50023C20.6716 1.67181 19.3284 1.6718 18.5 2.50023L8.93723 12.0629C8.59133 12.4088 8.41838 12.5818 8.29469 12.7836C8.18504 12.9626 8.10423 13.1576 8.05523 13.3617C7.99997 13.5919 7.99997 13.8365 7.99997 14.3257V16.0002Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span className="text-[#999999] text-[14px]">Edit Deal</span>
            </button>
          ) : null}
        </div>

        <div>
          <div className="grid grid-cols-2 gap-4">
            <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
              <NewField label="Name" value={activeDealData?.name} />

              <NewField
                label="Current Status"
                value={
                  isWon || isLost ? (
                    <span
                      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium ${
                        isWon
                          ? "bg-green-100 text-green-700"
                          : "bg-rose-100 text-rose-700"
                      }`}
                    >
                      {isWon ? (
                        <Trophy className="size-3" />
                      ) : (
                        <XCircle className="size-3" />
                      )}
                      {isWon ? "Won" : "Lost"}
                    </span>
                  ) : (
                    <span className="inline-block bg-blue-500 text-white px-3 py-1 rounded-full text-sm">
                      {activeDealData?.current_stage?.dealstatus}
                    </span>
                  )
                }
              />

              <NewField
                label="Deal Product"
                value={activeDealData?.deal_product_name}
              />
            </div>

            <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
              <NewField
                label="Package Name"
                value={activeDealData?.deal_package_name || "-"}
              />
              <NewField label="Amount" value={activeDealData?.dealamount} />

              <NewField label="Deal Key" value={activeDealData?.dealkey} />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <NewField label="Date" value={activeDealData?.created_at} />

            <div className="flex gap-2 items-center">
              <div className="flex gap-1 items-center">
                <button
                  onClick={() => !isWonOrLost && handleStageChange("Won")}
                  title="Mark as Won"
                  disabled={isWonOrLost} // 👈 disables if won OR lost
                  className={`p-2 rounded-full transition duration-200 hover:scale-110 ${
                    isWon
                      ? "bg-green-500 text-white cursor-not-allowed"
                      : isWonOrLost
                        ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                        : "bg-slate-100 text-slate-500 hover:bg-green-100 hover:text-green-600"
                  }`}
                >
                  <ThumbsUp className="size-4" />
                </button>

                <button
                  onClick={() => !isWonOrLost && handleStageChange("Lost")}
                  title="Mark as Lost"
                  disabled={isWonOrLost} // 👈 disables if won OR lost
                  className={`p-2 rounded-full transition duration-200 hover:scale-110 ${
                    isLost
                      ? "bg-rose-500 text-white cursor-not-allowed"
                      : isWonOrLost
                        ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                        : "bg-slate-100 text-slate-500 hover:bg-rose-100 hover:text-rose-600"
                  }`}
                >
                  <ThumbsDown className="size-4" />
                </button>
              </div>

              
            </div>
          </div>
        </div>
      </div> */}

      {/* Details */}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <Card style={{ padding: 20 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 16,
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 700 }}>Deal Details</span>
            <span>
              {!isWonOrLost ? (
                // <button
                //   onClick={() => !isWonOrLost && setShowEditModal(true)}
                //   className={`flex items-center gap-[10px] px-[9px] py-[5px]  transition duration-200 hover:scale-90 ${
                //     isWonOrLost ? "opacity-40 cursor-not-allowed" : ""
                //   }`}
                //   title="Edit Deal"
                //   disabled={isWonOrLost}
                // >
                //   <svg
                //     xmlns="http://www.w3.org/2000/svg"
                //     width="24"
                //     height="24"
                //     viewBox="0 0 24 24"
                //     fill="none"
                //   >
                //     <path
                //       d="M11 4.00023H6.8C5.11984 4.00023 4.27976 4.00023 3.63803 4.32721C3.07354 4.61483 2.6146 5.07378 2.32698 5.63826C2 6.28 2 7.12008 2 8.80023V17.2002C2 18.8803 2 19.7204 2.32698 20.3622C2.6146 20.9266 3.07354 21.3856 3.63803 21.6732C4.27976 22.0002 5.11984 22.0002 6.8 22.0002H15.2C16.8802 22.0002 17.7202 22.0002 18.362 21.6732C18.9265 21.3856 19.3854 20.9266 19.673 20.3622C20 19.7204 20 18.8803 20 17.2002V13.0002M7.99997 16.0002H9.67452C10.1637 16.0002 10.4083 16.0002 10.6385 15.9449C10.8425 15.8959 11.0376 15.8151 11.2166 15.7055C11.4184 15.5818 11.5914 15.4088 11.9373 15.0629L21.5 5.50023C22.3284 4.67181 22.3284 3.32866 21.5 2.50023C20.6716 1.67181 19.3284 1.6718 18.5 2.50023L8.93723 12.0629C8.59133 12.4088 8.41838 12.5818 8.29469 12.7836C8.18504 12.9626 8.10423 13.1576 8.05523 13.3617C7.99997 13.5919 7.99997 13.8365 7.99997 14.3257V16.0002Z"
                //       stroke="black"
                //       stroke-width="2"
                //       stroke-linecap="round"
                //       stroke-linejoin="round"
                //     />
                //   </svg>
                //   <span className="text-[#999999] text-[14px]">Edit Deal</span>
                // </button>

                <button
                  onClick={() => !isWonOrLost && setShowEditModal(true)}
                  className={`${
                    isWonOrLost ? "opacity-40 cursor-not-allowed" : ""
                  }`}
                  title="Edit Deal"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    padding: "5px 12px",
                    borderRadius: 6,
                    border: `1px solid ${T.accent}25`,
                    background: T.accentLight,
                    color: T.accentText,
                    cursor: "pointer",
                    fontSize: 11,
                    fontWeight: 600,
                    fontFamily: "inherit",
                  }}
                >
                  <Icon name="edit" size={12} color={T.accentText} /> Edit
                </button>
              ) : null}
            </span>
          </div>
          {[
            { label: "Name", value: activeDealData?.name || "-" },
            { label: "Package", value: activeDealData?.deal_package_name },

            // {
            //   label: "Current Status",
            //   value:
            //     isWon || isLost ? (
            //       <span
            //         className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium ${
            //           isWon
            //             ? "bg-green-100 text-green-700"
            //             : "bg-rose-100 text-rose-700"
            //         }`}
            //       >
            //         {isWon ? (
            //           <Trophy className="size-3" />
            //         ) : (
            //           <XCircle className="size-3" />
            //         )}
            //         {isWon ? "Won" : "Lost"}
            //       </span>
            //     ) : (
            //       <span className="inline-block bg-blue-500 text-white px-3 py-1 rounded-full text-sm">
            //         {activeDealData?.current_stage?.dealstatus}
            //       </span>
            //     ),
            // },
            {
              label: "Amount",
              value: activeDealData?.dealamount || "-",
              highlight: true,
            },
            {
              label: "Current Status",
              value: activeDealData?.current_stage?.dealstatus,
              badge: true,
              color: STATUS_COLORS[activeDealData?.current_stage?.dealstatus],
            },

            {
              label: "Deal Product",
              value: activeDealData?.deal_product_name || "-",
            },

            { label: "Date Created", value: activeDealData?.deal_date || "-" },
            {
              label: "Deal Key",
              value: activeDealData?.dealkey || "-",
              mono: true,
            },
          ].map((field, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 0",
                borderBottom: i < 6 ? `1px solid ${T.cardBorder}` : "none",
              }}
            >
              <span style={{ fontSize: 12, color: T.textMuted }}>
                {field.label}
              </span>
              {field.badge ? (
                <Badge color={field.color}>{field.value}</Badge>
              ) : (
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: field.highlight ? 700 : 500,
                    color: field.highlight ? "#22c55e" : T.text,
                    fontFamily: field.mono ? "monospace" : "inherit",
                    fontSize: field.mono ? 11 : 13,
                  }}
                >
                  {field.value}
                </span>
              )}
            </div>
          ))}
        </Card>

        <Card style={{ padding: 20 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 16,
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 700 }}>Made By</span>
          </div>
          {[
            { label: "Name", value: activeDealData?.made_by?.name || "-" },

            {
              label: "Email",
              value: activeDealData?.made_by?.email || "-",
              action: true,
              isUrl: true,
              url: `mailto:${activeDealData?.made_by?.email}`,
            },
            {
              label: "Phone",
              value: activeDealData?.made_by?.phone || "-",
              action: true,
              isUrl: true,
              url: `tel:${activeDealData?.made_by?.phone}`,
            },
            { label: "Source", value: activeDealData?.made_by?.page_source },
          ].map((field, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 0",
                borderBottom: i < 6 ? `1px solid ${T.cardBorder}` : "none",
              }}
            >
              <span style={{ fontSize: 12, color: T.textMuted }}>
                {field.label}
              </span>
              {field.badge ? (
                <Badge color={field.color}>{field.value}</Badge>
              ) : (
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: field.highlight ? 700 : 500,
                    color: field.action ? T.accentText : T.text,
                    fontFamily: field.mono ? "monospace" : "inherit",
                    fontSize: field.mono ? 11 : 13,
                    cursor: field.action ? "pointer" : "default",
                  }}
                >
                  {field?.isUrl ? (
                    <a href={field?.url}>{field?.value}</a>
                  ) : (
                    field.value
                  )}
                </span>
              )}
            </div>
          ))}
        </Card>
      </div>

      {campaignMeta?.length > 0 || otherMeta?.length > 0 ? (
        <>
          {/* Other Information */}

          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 14 }}>
            <Card style={{ padding: 20 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 16,
                }}
              >
                <span style={{ fontSize: 14, fontWeight: 700 }}>
                  Additonal Information
                </span>
              </div>
              {campaignMeta?.length > 0
                ? campaignMeta?.map((field, i) => (
                    <NewMetaField
                      key={i}
                      label={field.meta_key
                        .replaceAll("_", " ")
                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                      value={field?.meta_value}
                    />
                  ))
                : null}
              {otherMeta?.length > 0 &&
                otherMeta?.map((field, i) => {
                  return (
                    <>
                      <NewMetaField
                        key={i}
                        label={field.meta_key
                          .replaceAll("_", " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                        value={field?.meta_value}
                      />
                    </>
                  );
                })}
            </Card>
          </div>
        </>
      ) : null}

      {/* <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 14 }}>
        <Card style={{ padding: 20 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 16,
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 700 }}>Deal Details</span>
          </div>
          {activeDealData?.stats?.length > 0 ? (
            activeDealData?.stats?.map((field, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 0",
                  borderBottom: i < 6 ? `1px solid ${T.cardBorder}` : "none",
                }}
              >
                <span style={{ fontSize: 12, color: T.textMuted }}>
                  {field.key.replaceAll("_", " ")}
                </span>
                {
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: field.highlight ? 700 : 500,
                      color: field.highlight ? "#22c55e" : T.text,
                      fontFamily: field.mono ? "monospace" : "inherit",
                      fontSize: field.mono ? 11 : 13,
                    }}
                  >
                    {field.value || "-"}
                  </span>
                }
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-sm col-span-2">
              No deal details available.
            </p>
          )}
        </Card>
        
      </div> */}

      {/* Deal Details */}
      {/* <div className="bg-white rounded-[10px] border border-[#e1e4ea] p-5 flex flex-col gap-[10px]">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-medium leading-normal">Deal Details</h2>
        </div>

        <div className="grid  md:grid-cols-2 py-[17px]  gap-y-[34px]">
          {activeDealData?.stats?.length > 0 ? (
            activeDealData.stats.map((item, i) => (
              <NewField
                key={i}
                label={item.key.replaceAll("_", " ")} // Convert deal_amount → Deal Amount
                value={item.value || "-"}
              />
            ))
          ) : (
            <p className="text-gray-500 text-sm col-span-2">
              No deal details available.
            </p>
          )}
        </div>
      </div> */}

      {/* Made By */}
      {/* <div className="bg-white rounded-[10px] border border-[#e1e4ea] p-5 flex flex-col gap-[10px]">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-medium leading-normal">Made By</h2>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
            <NewField label="Name" value={activeDealData?.made_by?.name} />
            <NewField label="Phone" value={activeDealData?.made_by?.phone} />
          </div>

          <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
            <NewField
              label="Source"
              value={activeDealData?.made_by?.page_source}
            />

            <NewField label="Email" value={activeDealData?.made_by?.email} />
          </div>
        </div>
      </div> */}

      {/* {campaignMeta?.length > 0 || otherMeta?.length > 0 ? (
        <>
         
          <div className="bg-white   p-5 rounded-[10px] border border-[#E1E4EA]">
            
            <div className="flex flex-col gap-y-[10px]">
              
              <div className="flex justify-between items-center">
                <p className="text-xl font-medium leading-normal">
                  Additonal Information
                </p>
              </div>

              <div>
                {campaignMeta?.length > 0 && (
                  <div className="grid gap-[15px] grid-cols-3">
                    {campaignMeta.map((st, i) => (
                      <div className="col-span-1 min-w-0 ">
                        <NewField
                          key={i}
                          label={st.meta_key
                            .replaceAll("_", " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                          value={st.meta_value || "-"}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div>
                {otherMeta?.length > 0 && (
                  <div className="grid gap-[15px] grid-cols-3">
                    {otherMeta.map((st, i) => (
                      <div className="col-span-1 min-w-0">
                        <NewField
                          key={i}
                          label={st.meta_key
                            .replaceAll("_", " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                          value={st.meta_value || "-"}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : null} */}

      {showEditModal && (
        <EmployeeDirectoryAddUpdate
          open={showEditModal}
          onClose={() => {
            setShowEditModal(false);
          }}
          data={activeDealData}
          tabIndex={1}
          contactId={leadDetail?.userid}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {/* Won Deal Modal */}
      {showWonModal && (
        <WonDeal
          wonFormDeal={wonFormDeal}
          onClose={() => setShowWonModal(false)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {showLostModal && (
        <LostDeal
          lostFormDeal={lostFormDeal}
          onClose={() => setShowLostModal(false)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {empPopup && (
        <DealQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
          DealStages={DealStages}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      )}
    </div>
  );
};

const Stages = ({ activeDealData = {} }) => {
  const apiCall = useApiCall();

  const isWon = activeDealData?.current_stage?.dealstatus === "Won";
  const isLost = activeDealData?.current_stage?.dealstatus === "Lost";

  return (
    <>
      {/* Deal Timeline */}
      {/* <div className="bg-white rounded-[10px] p-5  border border-[#e1e4ea]  flex flex-col gap-[10px]">
        {activeDealData?.stages?.length > 0 ? (
          <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto relative">
           
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-medium leading-normal">
                Deal Timeline
              </h2>
            </div>
            <div className="relative  border-slate-200 pl-4 ml-1 space-y-5">
              {activeDealData?.stages?.map((stage, index) => {
                const isLast = index === activeDealData.stages.length - 1;

                // Color map
                const statusColors = {
                  "Need Analysis": "bg-yellow-500",
                  "Value Proposition": "bg-blue-500",
                  "Identify Decision": "bg-violet-500",
                  Proposal: "bg-teal-500",
                  Review: "bg-indigo-500",
                  Won: "bg-green-500",
                  Lost: "bg-rose-500",
                };

                const colorClass =
                  statusColors[stage?.dealstatus] || "bg-gray-400";

                return (
                  <div
                    key={stage?.dealstatuslogid || index}
                    className="relative pl-6"
                  >
                   
                    <span
                      className={`absolute left-[-11px] top-1 w-3 h-3 rounded-full border-2 border-white shadow ${colorClass}`}
                    ></span>

                    
                    <div className="flex flex-col">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <span
                            className={`text-sm font-semibold ${colorClass.replace(
                              "bg-",
                              "text-",
                            )}`}
                          >
                            {stage?.dealstatus}
                          </span>
                          <span className="text-xs text-slate-400">
                            (by {stage?.user?.name || "System"})
                          </span>
                        </div>
                        <span className="text-xs text-slate-400">
                          
                          {stage?.logtime}
                        </span>
                      </div>

                      <div className="text-xs text-slate-500 mt-1">
                        Updated at:{" "}
                        {stage?.logtime
                          ? moment(stage?.logtime).format(
                              "DD-MMM-YYYY, hh:mm A",
                            )
                          : "-"}
                      </div>
                    </div>

                    
                    {!isLast && (
                      <span className="absolute left-[-3px] top-5 w-[2px] h-full bg-slate-200"></span>
                    )}
                  </div>
                );
              })}
            </div>
            
          </div>
        ) : (
          <p className="text-gray-400 text-sm italic">No Deal Stages.</p>
        )}
      </div> */}

      <div>
        {activeDealData?.stages?.length > 0 ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 0,
                position: "relative",
              }}
            >
              {/* Timeline items */}
              <div style={{ position: "relative", paddingLeft: 28 }}>
                {/* Vertical line */}
                <div
                  style={{
                    position: "absolute",
                    left: 11,
                    // top: 8,
                    // bottom: 8,
                    top: 25,
                    bottom: 40,
                    width: 2,
                    background: "#ddd8d2",
                    borderRadius: 1,
                  }}
                />

                {activeDealData?.stages?.map((a, index) => {
                  const color =
                    STATUS_COLORS[a?.dealstatus] || "#8b5cf6" || "#6b7280";

                  // Color map
                  const statusColors = {
                    "Need Analysis": "bg-yellow-500",
                    "Value Proposition": "bg-blue-500",
                    "Identify Decision": "bg-violet-500",
                    Proposal: "bg-teal-500",
                    Review: "bg-indigo-500",
                    Won: "bg-green-500",
                    Lost: "bg-rose-500",
                  };

                  const colorClass =
                    statusColors[a?.dealstatus] || "bg-gray-400";
                  return (
                    <div
                      key={a.id}
                      style={{ position: "relative", marginBottom: 8 }}
                    >
                      {/* Dot */}
                      <div
                        style={{
                          position: "absolute",
                          left: -22,
                          top: 25,
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          background: color + "20",
                          border: `2.5px solid ${color}`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 1,
                        }}
                      >
                        <div
                          style={{
                            width: 4,
                            height: 4,
                            borderRadius: "50%",
                            background: color,
                          }}
                        />
                      </div>

                      <Card hover style={{ padding: "14px 18px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 12,
                          }}
                        >
                          <div
                            style={{
                              width: 32,
                              height: 32,
                              borderRadius: 8,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: color + "12",
                              flexShrink: 0,
                            }}
                          >
                            <Icon
                              name={
                                activityIcons[
                                  a?.type?.toLocaleLowerCase() || "default"
                                ]
                              }
                              size={14}
                              color={color}
                            />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 8,
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 13,
                                  fontWeight: 600,
                                  color: T.text,
                                }}
                              >
                                {a?.dealstatus}
                              </span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                gap: 12,
                                marginTop: 5,
                                fontSize: 11,
                                color: T.textMuted,
                              }}
                            >
                              <span>Updated at: {a?.logtime || "-"}</span>
                              <span>by: {a.user?.name || "System"}</span>
                            </div>
                          </div>
                        </div>
                      </Card>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        ) : (
          <p className="text-gray-400 text-sm italic text-center">
            No stages timeline available.
          </p>
        )}
      </div>
    </>
  );
};

// const FollowUpsTab = ({
//   leadDetail,
//   onSuccess = () => { },
//   onError = () => { },
//   activeDealData = {},
//   UserList,
//   onFollowUpSuccess = () => { },
// }) => {
//   const [showActivityModal, setShowActivityModal] = useState(false);
//   const [selectedActivity, setSelectedActivity] = useState(null);

//   return (
//     <>
//       <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto">

//         <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//           <Card
//             style={{
//               padding: "12px 16px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//             }}
//           >
//             <span style={{ fontSize: 13, fontWeight: 600 }}>
//               Scheduled Follow-Ups
//             </span>
//             <ActionButton
//               icon="plus"
//               label="New Follow-Up"
//               variant="filled"
//               style={{ width: "auto", padding: "7px 14px", fontSize: 12 }}
//               onClick={() => {
//                 if (typeof setSelectedActivity === "function") {
//                   setSelectedActivity(null);
//                 }
//                 if (typeof setShowActivityModal === "function") {
//                   setShowActivityModal(true);
//                 }
//               }}
//             />
//           </Card>
//           {activeDealData?.schedules?.length > 0 ? (
//             activeDealData?.schedules?.map((f) => (
//               <Card
//                 key={f.id}
//                 hover
//                 style={{ padding: "14px 18px" }}
//                 onClick={() => {
//                   setSelectedActivity(f);
//                   setShowActivityModal(true);
//                 }}
//               >
//                 <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//                   <div
//                     style={{
//                       width: 10,
//                       height: 10,
//                       borderRadius: "50%",
//                       background:
//                         f.status?.toLowerCase() === "completed"
//                           ? "#22c55e"
//                           : priorityColors[f.priority],
//                       boxShadow:
//                         f.status?.toLowerCase() === "completed"
//                           ? "none"
//                           : `0 0 0 3px ${priorityColors[f.priority]}20`,
//                     }}
//                   />
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 13,
//                         fontWeight: 600,
//                         color: T.text,
//                         textDecoration:
//                           f.status.toLowerCase() === "completed"
//                             ? "line-through"
//                             : "none",
//                         opacity: f.status === "completed" ? 0.6 : 1,
//                       }}
//                     >
//                       {f?.note}
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         gap: 12,
//                         marginTop: 4,
//                         fontSize: 11,
//                         color: T.textMuted,
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                         }}
//                       >
//                         <Icon name="calendar" size={11} color={T.textMuted} />{" "}
//                         {f?.due_date}
//                       </span>
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                         }}
//                       >
//                         <Icon name="clock" size={11} color={T.textMuted} />{" "}
//                         {f?.due_time}
//                       </span>
//                     </div>
//                   </div>
//                   <Badge color={priorityColors[f.priority]}>{f.priority}</Badge>
//                 </div>
//               </Card>
//             ))
//           ) : (
//             <p className="text-gray-400 text-sm italic text-center">
//               No scheduled activities.
//             </p>
//           )}
//         </div>

//         {showActivityModal && (
//           <FollowUpPopup
//             onClose={() => {
//               setShowActivityModal(false);
//               setSelectedActivity({});
//             }}
//             CustomerData={selectedActivity}
//             tabIndex={2}
//             onError={onError}
//             onSubmit={onFollowUpSuccess}
//             id={activeDealData?.dealid}
//             entitytype="deal"
//             entityname={activeDealData.name}
//             UsersList={UserList}
//           />
//         )}
//       </div>

//     </>
//   );
// };

// old followups DAta
{
  /* // <div className="space-y-3">
            //   {activeDealData.schedules.map((sch, i) => {
            //     const isCompleted = sch.status?.toLowerCase() === "completed";
            //     const isPending = sch.status?.toLowerCase() === "pending";
            //     const isHigh = sch.priority?.toLowerCase() === "high";

            //     const typeColors = {
            //       meeting: "bg-blue-100 text-blue-700",
            //       call: "bg-emerald-100 text-emerald-700",
            //       email: "bg-indigo-100 text-indigo-700",
            //       task: "bg-amber-100 text-amber-700",
            //     };
            //     const typeBadge =
            //       typeColors[sch.type?.toLowerCase()] ||
            //       "bg-gray-100 text-gray-600";

            //     return (
            //       <div
            //         key={i}
            //         className="relative group rounded-xl border border-slate-200 bg-white/90 backdrop-blur-sm p-4 shadow-[0_1px_3px_rgba(0,0,0,0.06)] hover:shadow-lg transition-all duration-200"
            //       >
            //         {/* ✏️ Edit button — appears on hover only */
}
//         <button
//           onClick={() => {
//             setSelectedActivity(sch);
//             setShowActivityModal(true);
//           }}
//           className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 bg-white/70 hover:bg-white text-slate-600 hover:text-slate-800 p-1 rounded-full shadow-sm transition-all"
//         >
//           <Pencil className="h-4 w-4" />
//         </button>

//         {/* Header */}
//         <div className="flex justify-between items-start">
//           <div className="space-y-1">
//             <h3 className="text-sm font-semibold text-slate-800">
//               {sch.subject}
//             </h3>

//             <div className="flex items-center gap-2 flex-wrap">
//               <span
//                 className={`px-2 py-0.5 text-[11px] font-medium rounded-full capitalize ${typeBadge}`}
//               >
//                 {sch.type}
//               </span>
//               <span className="text-[11px] text-gray-500">
//                 Priority:{" "}
//                 <span
//                   className={`font-semibold ${
//                     isHigh ? "text-red-500" : "text-emerald-600"
//                   }`}
//                 >
//                   {sch.priority}
//                 </span>
//               </span>
//             </div>
//           </div>

//           <span
//             className={`px-2 py-0.5 text-[11px] font-medium rounded-full capitalize mt-1 ml-2 ${
//               isCompleted
//                 ? "bg-emerald-100 text-emerald-700"
//                 : isPending
//                   ? "bg-amber-100 text-amber-700"
//                   : "bg-gray-100 text-gray-600"
//             }`}
//           >
//             {sch.status}
//           </span>
//         </div>

//         {/* Note Section */}
//         {sch.note && (
//           <p className="mt-2 text-sm text-slate-700 border-l-2 border-emerald-400 pl-2 leading-relaxed">
//             {sch.note}
//           </p>
//         )}

//         {/* Footer */}
//         <div className="mt-3 flex flex-wrap justify-between items-center text-[12px] text-gray-500 gap-2 border-t border-slate-100 pt-2">
//           <div className="flex items-center gap-1.5">
//             <Calendar className="h-3.5 w-3.5 text-slate-400" />
//             <span>{sch.due_date}</span>
//             <Clock className="h-3.5 w-3.5 text-slate-400 ml-2" />
//             <span>{sch.due_time}</span>
//           </div>

//           <div className="flex items-center gap-1.5">
//             <User className="h-3.5 w-3.5 text-slate-400" />
//             <span className="truncate">
//               Created by <b>{sch.user?.name || "—"}</b>
//             </span>
//           </div>

//           <div className="flex items-center gap-1.5">
//             <User className="h-3.5 w-3.5 text-slate-400" />
//             <span>
//               Assigned to <b>{sch.assignee?.name || "—"}</b>
//             </span>
//           </div>
//         </div>
//       </div>
//     );
//   })}
// </div> */}

const Timeline = ({
  // DealStages = [],
  // onSuccess = () => {},
  // onError = () => {},
  activeDealData = {},
}) => {
  const isWon = activeDealData?.current_stage?.dealstatus === "Won";
  const isLost = activeDealData?.current_stage?.dealstatus === "Lost";

  return (
    <>
      <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto relative">
        {/* Deal Activity */}

        <div className="bg-white rounded-[10px] border border-[#e1e4ea] p-5 flex flex-col gap-[10px]">
          {activeDealData?.activities?.length ? (
            <>
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-medium leading-normal">
                  Deal Activity
                </h2>
              </div>

              <div className="flex flex-col h-full mt-5">
                <div className="flex-1 overflow-y-auto pr-4">
                  <div className="relative ml-1">
                    {/* ✅ Single clean vertical line */}
                    <div className="absolute left-3 top-0 h-full border-l-2 border-gray-200"></div>

                    {activeDealData?.activities?.map((act, i) => {
                      const userName = act?.user?.name || "U";
                      const userInitial = userName.charAt(0).toUpperCase();
                      const colors = [
                        "bg-emerald-500",
                        "bg-blue-500",
                        "bg-indigo-500",
                        "bg-rose-500",
                      ];
                      const userColor = "bg-slate-200";

                      return (
                        <div key={i} className="relative pl-10 pb-6">
                          {/* ✅ User Initial Circle */}
                          <div
                            className={`absolute left-0 top-0 flex items-center justify-center w-7 h-7 rounded-full bg-slate-200 text-slate-700 text-xs font-semibold`}
                          >
                            {userInitial}
                          </div>

                          {/* ✅ Activity content properly aligned */}
                          <div className="flex flex-col gap-1 pt-0.5">
                            <div className="flex justify-between items-center">
                              <p className="text-sm font-medium text-gray-800">
                                {act.log}
                              </p>
                              <p className="text-xs text-gray-400">
                                {act.logtime}
                              </p>
                            </div>

                            {act?.user?.name && (
                              <div className="flex items-center gap-1 text-xs text-gray-500">
                                <User className="h-3 w-3 text-gray-400" />
                                <span className="leading-none">
                                  by {act.user.name}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p className="text-gray-400 text-sm italic">
              No Timeline Available.
            </p>
          )}
        </div>
      </div>
    </>
  );
};
// const TimelineTab = ({
//   activeDealData,
//   onError,
//   onSubmit,
//   UserList,
//   onFollowUpSuccess = () => {},
// }) => {
//   const [showActivityModal, setShowActivityModal] = useState(false);
//   const [selectedActivity, setSelectedActivity] = useState(null);
//   const [type, setType] = useState("");

//   return (
//     <div>
//       {activeDealData?.activities?.length ? (
//         <>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 0,
//               position: "relative",
//             }}
//           >
//             {/* Quick log bar */}

//             <Card
//               style={{
//                 padding: "12px 16px",
//                 marginBottom: 12,
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//             >
//               <span
//                 style={{ fontSize: 12, color: T.textMuted, fontWeight: 500 }}
//               >
//                 Quick log:
//               </span>
//               {[
//                 "Call",
//                 "Meeting",
//                 "Email",
//                 "Follow-up",
//                 "Demo",
//                 "Chat",
//                 "Consultation",
//                 "Presentation",
//               ].map((type) => (
//                 <button
//                   key={type}
//                   onClick={() => {
//                     if (typeof setSelectedActivity === "function") {
//                       setSelectedActivity(null);
//                       setType(type);
//                       console.log("type", type);
//                     }
//                     if (typeof setShowActivityModal === "function") {
//                       setShowActivityModal(true);
//                       setType(type);
//                     }
//                   }}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 5,
//                     padding: "5px 12px",
//                     borderRadius: 20,
//                     border: `1px solid ${activityColors[type?.toLocaleLowerCase() || "default"]}25`,
//                     background:
//                       activityColors[type?.toLocaleLowerCase()] + "08",
//                     color: activityColors[type?.toLocaleLowerCase()],
//                     cursor: "pointer",
//                     fontSize: 11,
//                     fontWeight: 600,
//                     fontFamily: "inherit",
//                   }}
//                 >
//                   <Icon
//                     name={activityIcons[type?.toLocaleLowerCase() || "default"]}
//                     size={12}
//                     color={
//                       activityColors[type?.toLocaleLowerCase() || "default"]
//                     }
//                   />
//                   {type.charAt(0).toUpperCase() + type.slice(1)}
//                 </button>
//               ))}
//             </Card>

//             {/* Timeline items */}
//             <div style={{ position: "relative", paddingLeft: 28 }}>
//               {/* Vertical line */}
//               <div
//                 style={{
//                   position: "absolute",
//                   left: 11,
//                   top: 15,
//                   bottom: 40,
//                   width: 2,
//                   background: "#ddd8d2",
//                   borderRadius: 1,
//                 }}
//               />

//               {activeDealData?.activities?.map((a, i) => {
//                 const color =
//                   activityColors[a?.icon?.toLocaleLowerCase()] ||
//                   "#8b5cf6" ||
//                   "#6b7280";

//                 return (
//                   <div
//                     key={a.id}
//                     style={{ position: "relative", marginBottom: 8 }}
//                   >
//                     {/* Dot */}
//                     <div
//                       style={{
//                         position: "absolute",
//                         left: -22,
//                         top: 16,
//                         width: 12,
//                         height: 12,
//                         borderRadius: "50%",
//                         background: color + "20",
//                         border: `2.5px solid ${color}`,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         zIndex: 1,
//                       }}
//                     >
//                       <div
//                         style={{
//                           width: 4,
//                           height: 4,
//                           borderRadius: "50%",
//                           background: color,
//                         }}
//                       />
//                     </div>

//                     <Card
//                       hover
//                       // onClick={() =>
//                       //   setExpandedActivity(expanded ? null : a.id)
//                       // }
//                       style={{ padding: "14px 18px" }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "flex-start",
//                           gap: 12,
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: 32,
//                             height: 32,
//                             borderRadius: 8,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             background: color + "12",
//                             flexShrink: 0,
//                           }}
//                         >
//                           <Icon
//                             name={
//                               activityIcons[
//                                 a?.icon?.toLocaleLowerCase() || "default"
//                               ]
//                             }
//                             size={14}
//                             color={color}
//                           />
//                           {/* <div
//                             style={{
//                               width: 32,
//                               height: 32,
//                               borderRadius: 14,
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               background: `linear-gradient(135deg, ${T.accent}, #8b5cf6)`,
//                               color: "#fff",
//                               fontSize: 18,
//                               fontWeight: 700,
//                               flexShrink: 0,
//                             }}
//                           >
//                             {getInitials(a.user.name) || "U"}
//                           </div> */}
//                         </div>
//                         <div style={{ flex: 1, minWidth: 0 }}>
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "space-between",
//                               gap: 8,
//                             }}
//                           >
//                             <span
//                               style={{
//                                 fontSize: 13,
//                                 fontWeight: 600,
//                                 color: T.text,
//                               }}
//                             >
//                               {a.log}
//                             </span>
//                             {/* <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
//                                   {a?.outcome && <Badge color={color}>{a.outcome}</Badge>}
//                                   {a?.hasRecording && (
//                                     <div style={{
//                                       display: 'flex', alignItems: 'center', gap: 4, padding: '3px 8px',
//                                       borderRadius: 6, background: '#ef444412', cursor: 'pointer',
//                                     }}>
//                                       <Icon name="play" size={10} color="#ef4444" />
//                                       <span style={{ fontSize: 10, color: '#ef4444', fontWeight: 600 }}>REC</span>
//                                     </div>
//                                   )}
//                                 </div> */}
//                           </div>
//                           <div
//                             style={{
//                               display: "flex",
//                               gap: 12,
//                               marginTop: 5,
//                               fontSize: 11,
//                               color: T.textMuted,
//                             }}
//                           >
//                             <span>{a?.logtime}</span>
//                             <span>by {a.user.name}</span>
//                             {/* {a.duration && <span>{a.duration}</span>} */}
//                           </div>
//                         </div>
//                       </div>
//                     </Card>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </>
//       ) : (
//         <p className="text-gray-400 text-sm italic text-center">
//           No timeline available.
//         </p>
//       )}

//       {showActivityModal && (
//         <FollowUpPopup
//           onClose={() => {
//             setShowActivityModal(false);
//             setSelectedActivity({});
//           }}
//           CustomerData={{
//             entity_type: "deal",
//             entity_name: activeDealData?.name,
//             entity_id: activeDealData?.dealid,
//           }}
//           tabIndex={2}
//           onError={onError}
//           onSubmit={onFollowUpSuccess}
//           id={activeDealData?.dealid}
//           UsersList={UserList}
//           type={type.toLowerCase()}
//         />
//       )}
//     </div>
//   );
// };
const Comments = ({ activeDealData, updateCount = () => {} }) => {
  return (
    <>
      <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto relative">
        <div className="space-y-4 h-full">
          <CommentsSection
            type="deal"
            id={activeDealData?.dealid}
            apiBaseUrl="deal"
            title="true"
            updateCount={updateCount}
            data={activeDealData}
            HasPopupUi={false}
          />
        </div>
      </div>
    </>
  );
};
const Files = ({ activeDealData, updateCount = () => {} }) => {
  return (
    <>
      <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto">
        <FilesTab
          leadId={activeDealData?.dealid}
          attachments={activeDealData?.attachments}
          attachmenttype="deal"
          updateCount={updateCount}
          data={activeDealData}
        />
      </div>
    </>
  );
};

const Brief = ({ activeDealData }) => {
  return (
    <>
      <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto ">
        <div className="bg-white rounded-[10px] p-5  border border-[#e1e4ea]  flex flex-col gap-[10px]">
          {activeDealData?.briefs?.length > 0 ? (
            <div>
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-medium leading-normal">
                  Project Brief
                </h2>
              </div>
              {Array.isArray(activeDealData?.briefs) && (
                <div className="divide-y divide-slate-200">
                  {activeDealData?.briefs?.map((item, index) => {
                    // 🧠 Replace all URLs in answer with clickable links showing clean names
                    const formattedAnswer = item.answer
                      ? item.answer.replace(/(https?:\/\/[^\s,]+)/g, (url) => {
                          try {
                            const parts = url.split("/");
                            const fileName = parts[parts.length - 1];

                            // 🧩 Check if it looks like a file link
                            const isFile = /\.[a-zA-Z0-9]{2,5}($|\?)/.test(
                              fileName,
                            );

                            let displayText;
                            if (isFile) {
                              displayText = decodeURIComponent(fileName);
                            } else {
                              const domain = new URL(url).hostname.replace(
                                "www.",
                                "",
                              );
                              const path = new URL(url).pathname.replace(
                                /^\/|\/$/g,
                                "",
                              );
                              displayText = `${domain}/${path}`.slice(0, 60); // Trim long paths
                            }

                            return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline break-all">${displayText}</a>`;
                          } catch {
                            return url;
                          }
                        })
                      : "—";

                    // Add space between multiple links for readability
                    const spacedAnswer = formattedAnswer.replace(
                      /<\/a>\s*(?=<a )/g,
                      "</a> &nbsp;&nbsp;",
                    );

                    return (
                      <div key={index} className="py-4">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:gap-4">
                          <div className="sm:w-1/3">
                            <h3 className="text-sm font-semibold text-slate-700">
                              {item.question}
                            </h3>
                          </div>
                          <div className="sm:flex-1">
                            <p
                              className="text-sm text-slate-600 leading-relaxed whitespace-pre-line break-words"
                              dangerouslySetInnerHTML={{ __html: spacedAnswer }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ) : (
            <p className="text-gray-400 italic text-sm">
              No brief data available.
            </p>
          )}
        </div>
      </div>
    </>
  );
};

const DealInfo = ({
  leadDetail,
  PackageList = [],
  UserList = [],
  ProductList = [],
  DealStages = [],
  ClientList = [],
  onSuccess = () => {},
  onError = () => {},
  loading = () => {},
  activeDealData = {},
  updateData = () => {},
  clientDeals = [],
  reloadData = () => {},
  onFollowUpSuccess = () => {},
  updateCount = () => {},
  followUp = "",
  followUpID = "",
}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showWonModal, setShowWonModal] = useState(false);
  const [wonFormDeal, setWonFormDeal] = useState(null);
  const [showLostModal, setShowLostModal] = useState(false);
  const [lostFormDeal, setLostFormDeal] = useState(null);

  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});

  const [localStage, setLocalStage] = useState(
    activeDealData?.current_stage?.dealstatus ?? "-",
  );

  const apiCall = useApiCall();

  const handleSuccess = (message) => {
    if (onSuccess) onSuccess(message); // ✅ call parent prop
    setShowEditModal(false);
    setShowWonModal(false);
    setWonFormDeal(null);
    setShowLostModal(false);
    setLostFormDeal(null);

    setEmpPopup(false);
    setEmpData({});
  };

  const handleError = (message) => {
    if (onError) onError(message); // ✅ call parent prop
  };

  // const stage = deal?.current_stage?.dealstatus ?? "-";

  const metas = Object.fromEntries(
    activeDealData?.metas?.map((m) => [m?.meta_key, m?.meta_value]) ?? [],
  );

  const isWon = activeDealData?.current_stage?.dealstatus === "Won";
  const isLost = activeDealData?.current_stage?.dealstatus === "Lost";

  const formatStageKey = (stage) => {
    return stage.toLowerCase().replace(/\s+/g, "_"); // "In Progress" -> "in_progress"
  };

  // --- HANDLE STAGE CHANGE ---
  const handleStageChange = async (newStage) => {
    const lowerStage = formatStageKey(newStage); // lowercase + underscores
    const currentStage = activeDealData?.current_stage?.dealstatus ?? "-"; // ✅ added

    if (lowerStage === "won") {
      setWonFormDeal(activeDealData);
      setShowWonModal(true);
      return;
    }

    if (lowerStage === "lost") {
      setLostFormDeal({
        dealkey: activeDealData.dealkey,
        name: activeDealData.name,
      });
      setShowLostModal(true);
      return;
    }

    const resultSwal = await Swal.fire({
      title: `Move deal "${activeDealData.name}"?`,
      text: `Move from "${currentStage}" to "${newStage}"?`, // ✅ fixed reference
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    });

    if (resultSwal.isConfirmed) {
      try {
        await apiCall({
          method: "post",
          url: "deals/update-deal-status",
          data: { dealkey: activeDealData.dealkey, dealstatus: lowerStage },
        });

        // **Update card immediately without reload**
        // onStatusChange(activeDealData.dealid, newStage); // ✅ keep `newStage` or `lowerStage` depending on your display logic

        updateData({
          ...activeDealData,
          current_stage: {
            ...activeDealData.current_stage,
            dealstatus: newStage,
          },
        });

        Swal.fire("Success!", `Deal moved to "${newStage}"`, "success");
      } catch (err) {
        Swal.fire(
          "Error",
          err?.response?.data?.message || "Something went wrong",
          "error",
        );
      }
    }
  };

  const TabButton = ({ active, label, count, onClick }) => {
    const [hovered, setHovered] = useState(false);
    return (
      <button
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        title={label == "Stages" ? "History" : null}
        style={{
          padding: "8px 16px",
          borderRadius: 8,
          border: "none",
          background: active
            ? T.accent
            : hovered
              ? "rgba(0,0,0,0.04)"
              : "transparent",
          color: active ? "#fff" : hovered ? T.text : T.textSecondary,
          cursor: "pointer",
          fontSize: 13,
          fontWeight: active ? 600 : 500,
          fontFamily: "inherit",
          transition: "all 0.15s",
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        {label}
        {count !== undefined && (
          <span
            style={{
              background: active
                ? "rgba(255,255,255,0.25)"
                : "rgba(0,0,0,0.06)",
              padding: "1px 7px",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 600,
              color: active ? "#fff" : T.textMuted,
            }}
          >
            {count}
          </span>
        )}
      </button>
    );
  };

  // ─── STAGE PROGRESS ───
  const StageProgress = ({ stages, currentIndex, onStageClick }) => {
    const [hoveredStage, setHoveredStage] = useState(null);
    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 0, width: "100%" }}
      >
        {stages?.map((stage, i) => {
          const isCompleted = i < currentIndex;
          const isCurrent = i === currentIndex;
          const isHovered = hoveredStage === i;
          const color = STATUS_COLORS[stage] || T.accent;
          return (
            <div
              key={stage}
              style={{ flex: 1, display: "flex", alignItems: "center" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                  flex: 1,
                  cursor: "pointer",
                  position: "relative",
                }}
                onMouseEnter={() => setHoveredStage(i)}
                onMouseLeave={() => setHoveredStage(null)}
                onClick={() => onStageClick(i)}
              >
                {/* Node */}
                <div
                  style={{
                    width: isCurrent ? 36 : 28,
                    height: isCurrent ? 36 : 28,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: isCompleted
                      ? color
                      : isCurrent
                        ? color
                        : isHovered
                          ? color + "20"
                          : "#e8e5e0",
                    border: isCurrent ? `3px solid ${color}40` : "none",
                    boxShadow: isCurrent
                      ? `0 0 0 4px ${color}15, 0 2px 8px ${color}30`
                      : isHovered
                        ? `0 0 0 3px ${color}15`
                        : "none",
                    transition: "all 0.2s",
                    transform: isHovered && !isCurrent ? "scale(1.15)" : "none",
                  }}
                >
                  {isCompleted ? (
                    <Icon name="check" size={14} color="#fff" />
                  ) : isCurrent ? (
                    <div
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        background: "#fff",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: isHovered ? color : "#c4c0bb",
                      }}
                    />
                  )}
                </div>
                {/* Label */}
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: isCurrent ? 700 : isCompleted ? 600 : 500,
                    color: isCurrent
                      ? color
                      : isCompleted
                        ? T.text
                        : T.textMuted,
                    textAlign: "center",
                    lineHeight: 1.2,
                    whiteSpace: "nowrap",
                  }}
                >
                  {stage}
                </span>
                {/* Click hint */}
                {isHovered && !isCurrent && (
                  <span
                    style={{
                      position: "absolute",
                      top: -28,
                      background: T.text,
                      color: "#fff",
                      padding: "3px 8px",
                      borderRadius: 6,
                      fontSize: 10,
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Click to move here
                  </span>
                )}
              </div>
              {/* Connector */}
              {i < stages.length - 1 && (
                <div
                  style={{
                    height: 3,
                    flex: 1,
                    borderRadius: 2,
                    marginTop: -20,
                    background: isCompleted ? color : "#e0ddd8",
                    transition: "all 0.3s",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const TAB_CONFIG = [
    {
      key: "timeline",
      label: "Timeline",
      component: (
        <TimelineTab
          leadDetail={activeDealData}
          UsersList={UserList}
          onSubmit={onFollowUpSuccess}
          onError={onError}
          MainIndex="1"
        />
      ),
      count: activeDealData?.activities_count,
    },
    {
      key: "deals",
      label: "Deal Info",
      component: (
        <Details
          leadDetail={leadDetail}
          DealStages={DealStages}
          onSuccess={onSuccess}
          onError={onError}
          updateData={updateData}
          clientDeals={clientDeals}
          activeDealData={activeDealData}
          // ProductList={ProductList}
          // PackageList={PackageList}
          // ClientList={ClientList}
          // UserList={UserList}
          // loading={loading}
        />
      ),
    },
    {
      key: "stages",
      label: "Stages",
      component: (
        <Stages
          ProductList={ProductList}
          PackageList={PackageList}
          DealStages={DealStages}
          ClientList={ClientList}
          UserList={UserList}
          leadDetail={leadDetail}
          activeDealData={activeDealData}
          loading={loading}
          onSuccess={onSuccess}
          onError={onError}
          updateData={updateData}
        />
      ),
      // count:activeDealData?.stages?.length
    },
    {
      key: "followups",
      label: "Follow ups",
      component: (
        // <FollowUpsTab
        //   leadDetail={leadDetail}
        //   activeDealData={activeDealData}
        //   onSubmit={onSuccess}
        //   onError={onError}
        //   UserList={UserList}
        //   onFollowUpSuccess={onFollowUpSuccess}
        // />
        <FollowUpsTab
          leadDetail={activeDealData}
          onSubmit={onFollowUpSuccess}
          onError={onError}
          UsersList={UserList}
          id={activeDealData?.dealid}
          entitytype="deal"
          entityname={activeDealData.name}
          followUpID={followUpID ?? ""}
        />
      ),
      count: activeDealData?.schedules_count,
    },
    {
      key: "comments",
      label: "Comments",
      component: (
        <Comments
          leadDetail={leadDetail}
          activeDealData={activeDealData}
          updateCount={updateCount}
          onSubmit={onSuccess}
          onError={onError}
        />
      ),
      count: activeDealData?.comments_count,
    },
    {
      key: "files",
      label: "Files",
      component: (
        <Files
          leadId={activeDealData?.userid}
          attachments={activeDealData?.attachments}
          attachmenttype="contact"
          activeDealData={activeDealData}
          updateCount={updateCount}
          onSubmit={onSuccess}
          onError={onError}
        />
      ),

      count: activeDealData?.attachments_count,
    },
    // {
    //   key: "briefs",
    //   label: "Briefs",
    //   component: (
    //     <Brief
    //       leadId={activeDealData?.userid}
    //       attachments={activeDealData?.attachments}
    //       attachmenttype="contact"
    //       activeDealData={activeDealData}
    //       onSubmit={onSuccess}
    //       onError={onError}
    //     />
    //   ),
    // },
  ].filter(Boolean);

  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (followUp) {
      setTab(3);
    }
  }, []);

  const [tabsCustomizeTabs, setTabsCustomizeTabs] = useState({
    timeline: true,
    deals: true,
    stages: true,
    followups: true,
    comments: true,
    files: true,
    briefs: true,
  });

  const handleTabChange = (index) => {
    setTab(index);
  };

  const renderedTabs = useMemo(() => {
    return TAB_CONFIG.map((tabItem, index) => {
      if (tabItem.key !== "timeline" && !tabsCustomizeTabs[tabItem.key])
        return null;
      return (
        <TabButton
          key={tabItem.key}
          active={tab === index}
          label={tabItem.label}
          count={tabItem.count}
          onClick={() => {
            if (tabItem?.component) {
              handleTabChange(index);
            }

            if (tabItem.key == "timeline") {
              reloadData();
            }
          }}
        />
        // <li
        //   key={tabItem.key}
        //   className={`${tab === index ? Style.active : null}`}
        // onClick={() => {
        //   if (tabItem?.component) {
        //     handleTabChange(index);
        //   }
        // }}
        // >
        //   <div className={Style.icon}></div>
        //   <span>{tabItem.label}</span>
        // </li>
      );
    });
  }, [tab, tabsCustomizeTabs, activeDealData]);

  return (
    <>
      {/* <div> */}
      {loading || !activeDealData?.dealid ? (
        <div className="w-full h-full flex justify-center items-center">
          <InnerLoader />
        </div>
      ) : (
        <>
          {/* Project Header */}

          <Card
            style={{
              padding: "6px 8px",
              display: "flex",
              gap: 4,
              flexWrap: "wrap",
            }}
          >
            {renderedTabs}
          </Card>

          <div className="flex flex-col h-screen overflow-auto">
            {TAB_CONFIG.map(
              (tabItem, index) =>
                //   <div>
                tab === index && (
                  <Suspense
                    key={tabItem?.key}
                    fallback={
                      <div className="tableDataLoader">
                        <div className="tableDataLoader-wrapper">
                          <div className="loader"></div>
                          <span>Data Load...</span>
                        </div>
                      </div>
                    }
                  >
                    {tabItem?.component}
                  </Suspense>
                ),
              //   </div>
            )}
          </div>
        </>
      )}

      {showEditModal && (
        <EmployeeDirectoryAddUpdate
          open={showEditModal}
          onClose={() => {
            setShowEditModal(false);
          }}
          data={activeDealData}
          tabIndex={1}
          contactId={leadDetail?.id}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {/* Won Deal Modal */}
      {showWonModal && (
        <WonDeal
          wonFormDeal={wonFormDeal}
          onClose={() => setShowWonModal(false)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {showLostModal && (
        <LostDeal
          lostFormDeal={lostFormDeal}
          onClose={() => setShowLostModal(false)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {empPopup && (
        <DealQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
          DealStages={DealStages}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      )}

      {show && (
        <CustomizeTabsOverviewPopup
          data={TAB_CONFIG.map((t) => t)}
          tabs={tabsCustomizeTabs}
          onClose={() => setShow(false)}
          onToggle={(tabName) => {
            if (tabName === "deals") return; //
            setTabsCustomizeTabs((prev) => ({
              ...prev,
              [tabName]: !prev[tabName],
            }));
            handleTabChange(0);
          }}
        />
      )}
    </>
  );
};

export default DealInfo;
